import React from 'react'
import { Checkmark } from '../../atoms/NewIcons'
import { Trans } from '../../atoms'

const StepItemOrdine = ({ placeholder, children }) => {
  const CheckMarkIcon = () => <Checkmark classes="personalizzazione__item__step__icon" />
  return (
    <div className="personalizzazione__item">
      <div className={`personalizzazione__item__container`}>
        <div className="personalizzazione__item__wrapper">
          <div className={`personalizzazione__item__step`}>
            <CheckMarkIcon />
          </div>
          <p className="personalizzazione__item__placeholder">
            <Trans chiave={placeholder} />
          </p>
        </div>
      </div>
      <div className="personalizzazione__item__recap">{children}</div>
    </div>
  )
}

export default StepItemOrdine
